// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"xo-z","zenCrossSiteLabel":"yo-z","vrsnlCrossSiteLabel":"zo-z"};